import React, { useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import InputControl from "../../Components/Common/TextField/TextField";
import CustomButton from "../../Components/Button/Button";
import Button from "@mui/material/Button";
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import "./VcoiAddNewFormLevel.css";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import logo from "../../images/logo-publicis-groupe.svg"
import {
  styled
} from '@mui/material';
import { useDispatch } from "react-redux";
import { SaveFormLabels } from "../../Reducers/dcoi";
import Toster from "../../Components/Common/Toster/Toster";



const StepNumber = styled(Box)(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: '#212129',
  fontWeight: "bolder",
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(2),
}));

const StepHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '1rem',
});

export default function VcoiAddNewFormLevel() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const formLabelsData = location?.state?.formLabels || {};
  const [activeMenu, setActiveMenu] = useState("SUBMISSION PAGE");
  const [isEditing1, setIsEditing1] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [isEditing3, setIsEditing3] = useState(false);
  const [isEditing4, setIsEditing4] = useState(false);
  const [isEditing5, setIsEditing5] = useState(false);
  const [isEditing6, setIsEditing6] = useState(false);
  const [isEditing7, setIsEditing7] = useState(false);
  const [isEditing8, setIsEditing8] = useState(false);
  const [isEditing9, setIsEditing9] = useState(false);
  const [isEditing10, setIsEditing10] = useState(false);
  const [isEditing11, setIsEditing11] = useState(false);
  const [isEditing12, setIsEditing12] = useState(false);
  const [isEditing13, setIsEditing13] = useState(false);
  const [isEditing14, setIsEditing14] = useState(false);
  const [isEditing15, setIsEditing15] = useState(false);
  const [isEditing16, setIsEditing16] = useState(false);
  const [isEditing17, setIsEditing17] = useState(false);
  const [isEditing18, setIsEditing18] = useState(false);
  const [isEditing181, setIsEditing181] = useState(false);
  const [isEditing19, setIsEditing19] = useState(false);
  const [isEditing20, setIsEditing20] = useState(false);
  const [isEditing21, setIsEditing21] = useState(false);
  const [isEditing22, setIsEditing22] = useState(false);
  const [isEditing23, setIsEditing23] = useState(false);
  const [isEditing24, setIsEditing24] = useState(false);
  const [isEditing25, setIsEditing25] = useState(false);
  const [isEditing26, setIsEditing26] = useState(false);
  const [isEditing27, setIsEditing27] = useState(false);
  const [isEditing28, setIsEditing28] = useState(false);
  const [isEditing29, setIsEditing29] = useState(false);
  const [isEditing30, setIsEditing30] = useState(false);
  const [isEditing31, setIsEditing31] = useState(false);
  const [isEditing32, setIsEditing32] = useState(false);
  const [isEditing33, setIsEditing33] = useState(false);
  const [isEditing34, setIsEditing34] = useState(false);
  const [isEditing35, setIsEditing35] = useState(false);
  const [isEditing36, setIsEditing36] = useState(false);
  const [isEditing37, setIsEditing37] = useState(false);
  const [isEditing38, setIsEditing38] = useState(false);
  const [isEditing39, setIsEditing39] = useState(false);
  const [isEditing40, setIsEditing40] = useState(false);
  const [isEditing41, setIsEditing41] = useState(false);
  const [isEditing42, setIsEditing42] = useState(false);
  const [isEditing43, setIsEditing43] = useState(false);
  const [isEditing44, setIsEditing44] = useState(false);
  const [isEditing45, setIsEditing45] = useState(false);
  const [isEditing46, setIsEditing46] = useState(false);
  const [isEditing47, setIsEditing47] = useState(false);
  const [isEditing48, setIsEditing48] = useState(false);
  const [isEditing49, setIsEditing49] = useState(false);
  const [isEditing50, setIsEditing50] = useState(false);
  const [isEditing51, setIsEditing51] = useState(false);
  const [isEditing52, setIsEditing52] = useState(false);
  const [isEditing53, setIsEditing53] = useState(false);
  const [isEditing54, setIsEditing54] = useState(false);
  const [isEditing55, setIsEditing55] = useState(false);
  const [isEditing56, setIsEditing56] = useState(false);
  const [isEditing57, setIsEditing57] = useState(false);
  const [isEditing58, setIsEditing58] = useState(false);
  const [isEditing59, setIsEditing59] = useState(false);
  const [isEditing60, setIsEditing60] = useState(false);
  const [isEditing61, setIsEditing61] = useState(false);
  const [isEditing62, setIsEditing62] = useState(false);
  const [isEditing63, setIsEditing63] = useState(false);
  const [isEditing64, setIsEditing64] = useState(false);
  const [isEditing65, setIsEditing65] = useState(false);
  const [isEditing66, setIsEditing66] = useState(false);
  const [isEditing67, setIsEditing67] = useState(false);
  const [isEditing68, setIsEditing68] = useState(false);
  const [isEditing69, setIsEditing69] = useState(false);
  const [isEditing70, setIsEditing70] = useState(false);
  const [isEditing71, setIsEditing71] = useState(false);
  const [isEditing73, setIsEditing73] = useState(false);
  const [isEditing74, setIsEditing74] = useState(false);
  const [isEditing75, setIsEditing75] = useState(false);
  const [isEditing76, setIsEditing76] = useState(false);
  const [isEditing77, setIsEditing77] = useState(false);
  const [isEditing78, setIsEditing78] = useState(false);
  const [isEditing79, setIsEditing79] = useState(false);
  const [isEditing80, setIsEditing80] = useState(false);
  const [isEditing81, setIsEditing81] = useState(false);
  const [isEditing82, setIsEditing82] = useState(false);
  const [isEditing83,setIsEditing83] = useState(false);
  const [isEditing84,setIsEditing84] = useState(false);

  const isFormValid = () => {
    // Flatten the object to check for empty values
    const checkFields = (obj) => {
      return Object.values(obj).some(value => {
        if (typeof value === "object") return checkFields(value); // Recursively check nested objects
        return value === "" || value === null || value === undefined;
      });
    };

    return !checkFields(values); // If any field is empty, return false
  };
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState();
  const [severity, setSavirity] = useState();
  const [values, setValues] = useState({
    Language: { titel: formLabelsData?.Language || "English" },
    SubmissionPage: {
      ButtonTitle: formLabelsData?.Key_MySubmission_3 || "Read Policy",
      Title: formLabelsData?.Key_MySubmission_1 || "New Conflict of Interest Disclosure Statement is been sent to you. You are required to sign-off 'Conflict Interest Disclosure Statement'",
      Statement: formLabelsData?.Key_MySubmission_4 || "Your Conflict of Interest Disclosure Statements",
      CurrentStatus: formLabelsData?.Key_MySubmission_5 || "CURRENT STATUS",
      Submitted: formLabelsData?.Key_MySubmission_6 || "SUBMITTED",
      UnSubmitted: formLabelsData?.Key_MySubmission_7 || "UNSUBMITTED",
      UnBlock: formLabelsData?.Key_MySubmission_8 || "UNBLOCKED",
      Year: formLabelsData?.Key_MySubmission_9 || "Year",
      Location: formLabelsData?.Key_MySubmission_10 || "Location",
      jobTitle: formLabelsData?.Key_MySubmission_11 || "jobTitle",
      hfmCode: formLabelsData?.Key_MySubmission_12 || "HfmCode",
      signOff: formLabelsData?.Key_MySubmission_13 || "SignOff",
      viewSubmittion: formLabelsData?.Key_MySubmission_14 || "View submission",
      status: formLabelsData?.Key_MySubmission_16 || "You do not have any active submission.",
    },
    SubmissionFormTemplate: {
      step1: {
        Titel: formLabelsData?.Key2 || "Confirm Personal Information",
        Titel1: formLabelsData?.Key1 ||
          "I list below all existing and/or potential conflicts of interest, and certify that I have received approval/consent for such conflicts. I understand that should new conflicts present themselves, or substantive changes to existing conflicts occur, it is my responsibility to bring these forward per Janus to re-affirm approval. I further understand and acknowledge that the Company reserves the right, in its sole discretion, to request that I cease involvement in any of the Declared Conflicts of Interest for any reason at any time. In such circumstances, I agree to cease all engagement or involvement of the Declared Conflicts of Interest immediately.",
        Titel2: formLabelsData?.Key40 ||
          "As the Conflict of Interest form is a legal document, the information below is meant to display your legal name and title information in Career Settings. If you have questions or concerns about this information, please reach out to your local HR Partner.",
        Warning: formLabelsData?.Key23 || "Warning! Some of your information are missing. Please raise a ticket on Service Now to update your information before submission. Thank you!",
        EmployeeName: formLabelsData?.Key3 || "EmployeeName",
        JobTitle: formLabelsData?.Key4 || "JobTitle",
        JoiningDate:formLabelsData?.JoiningDate || "JoiningDate",
        hfmCode: formLabelsData?.Key6 || "HfmCode",
        company: formLabelsData?.Key5 || "Company",
        aggrement: formLabelsData?.Key7 || "Yes, the above mentioned details are correct",
        ButtonTitle1: formLabelsData?.Key28 || "BACK",
        ButtonTitle2: formLabelsData?.Key8 || "NEXT"
      },
      step2: {
        Titel: formLabelsData?.Key9 || "Conflict of Interest Disclosure Statement",
        aggrement: formLabelsData?.Key10 || "Yes, the above mentioned details are correct",
        ButtonTitle1: formLabelsData?.Key28 || "BACK",
        ButtonTitle2: formLabelsData?.Key8 || "NEXT"
      },
      // step3: {
      //   Titel: formLabelsData?.Key11 || "Conflict of Interest Declaration",
      //   selectNo: formLabelsData?.Key12 || "I don't have existing and/or potential conflict of interest",
      //   selectYes: formLabelsData?.Key13 || "I want to add existing and/or potential conflict of interest.",
      //   aggrement: formLabelsData?.Key14 || "Yes, the above mentioned details are correct",
      //   index: 1,
      //   tableh1: formLabelsData?.key15 || "COMPANY / MARKET",
      //   tableh2: formLabelsData?.key16 || "Details of Existing or Potential Conflict of Interest",
      //   aggrement1: formLabelsData?.Key19 ||
      //     "Please contact your Human Resources Representative with any queries or if you need further clarification regarding this document or the Policy.",
      //   ButtonTitle1: formLabelsData?.Key28 || "BACK",
      //   ButtonTitle2: formLabelsData?.Key8 || "NEXT",
      //   ButtonTitle3: formLabelsData?.Key18 || "+ ADD MORE"
      // },
      step3: {
        Titel: formLabelsData?.Key11 || "Conflict of Interest Declaration",
        selectNo: formLabelsData?.Key12 || "I don't have existing and/or potential conflict of interest",
        selectYes: formLabelsData?.Key13 || "I want to add existing and/or potential conflict of interest.",
        aggrement: formLabelsData?.Key14 || "Yes, the above mentioned details are correct",
        index: formLabelsData?.id || 1,
        tableh1: formLabelsData?.Key35 || "COMPANY / MARKET",
        tableh2: formLabelsData?.Key36 || "Vendor / SubContractor",
        tableh3: formLabelsData?.Key37 || "Conflict of Intrest Details",
        ButtonTitle1: formLabelsData?.Key28 || "BACK",
        ButtonTitle2: formLabelsData?.Key8 || "NEXT",
        // ButtonTitle3: formLabelsData?.Key18 || "+ ADD MORE"

      },
      step4: {
        titel: formLabelsData?.Key38 || "Politically exposed Person (PEP) Statement",
        aggrement: formLabelsData?.Key31 || "I read and totally agree with the policy above",
        ButtonTitle1: formLabelsData?.Key28 || "BACK",
        ButtonTitle2: formLabelsData?.Key8 || "NEXT"
      },
      step5: {
        Titel: formLabelsData?.Key30 || "Politically exposed Person (PEP) Declaration",
        selectNo: formLabelsData?.Key32 || "I am not a Politically Exposed Person",
        selectYes: formLabelsData?.Key33 || "I am a Politically Exposed Person",
        aggrement: formLabelsData?.Key34 ||
          "I list below all positions held as a PEP including the name of the organization, the role and the end date of employment. I understand that should new positions present themselves, or substantive changes to existing positions occur, it is my responsibility to bring these forward per Janus to re-affirm approval.",
        index: formLabelsData?.id || 1,
        tableh1: formLabelsData?.Key35 || "Name of the Organization",
        tableh2: formLabelsData?.Key36 || "Role",
        tableh3: formLabelsData?.Key37 || "End Date of Employment",
        ButtonTitle1: formLabelsData?.Key28 || "BACK",
        ButtonTitle2: formLabelsData?.Key8 || "NEXT",
        ButtonTitle3: formLabelsData?.Key18 || "+ ADD MORE"

      },
      step6: {
        titel: formLabelsData?.Key20 || "Sign-off & Submit",
        aggrement: formLabelsData?.Key21 ||
          "I agree and confirm that all information entered in this document is true and correct*",
        ButtonTitle1: formLabelsData?.Key28 || "BACK",
        ButtonTitle2: formLabelsData?.Key22 || "SUBMIT"
      },
    },
    SubmittedPageTemplate: {
      title: formLabelsData?.Key24 || "Your Conflict of Disclosure Statement {0} has been successfully submitted",
      body: formLabelsData?.Key25 || "Please contact your Human Resources Representative with any queries or if you need further clarification regarding this document or the Policy.",
      ButtonTitle1: formLabelsData?.Key26 || "View Submission",
      ButtonTitle2: formLabelsData?.Key27 || "Logout"
    },
    ErrorPage: {
      title: formLabelsData?.Key_MySubmission_15 || "New Conflict of Interest Disclosure Statement is not available for your HFM Code",
      ButtonTitle1: formLabelsData?.Key26 || "View Submission",
      ButtonTitle2: formLabelsData?.Key27 || "Logout"
    },
    PdfTemplate: {
      title1: formLabelsData?.Key_pdf_1 || "CONFLICTS OF INTEREST AND SERVICE TO OUTSIDE ORGANIZATIONS",
      title2: formLabelsData?.Key_pdf_3 || "ANNUAL SELF CERTIFICATION",
      title3: formLabelsData?.Key_pdf_4 || "All employees are required to disclose and obtain approval of all actual and potential conflicts of interest as soon as they arise.  See the Janus Conflicts of Interest Policy for more information and examples of conflicts of interest.",
      tableh1: formLabelsData?.Key42 || "Conflict Of Interest",
      tableh2: formLabelsData?.Key43 || "Politically Exposed Person",
      signOff: formLabelsData?.Key_pdf_11 || "SIGN-OFF",
      name: formLabelsData?.Key_pdf_5 || "SIGNED",
      date: formLabelsData?.Key_pdf_9 || "DATE",
      aggrementTitel1: formLabelsData?.Key_pdf_8 || "CONFLICTS OF INTEREST POLICY",
      aggrementTitel2: formLabelsData?.Key_pdf_12 || "POLITICALLY EXPOSED PERSON DISCLOSURE STATEMENT",
    }, MasterPage: {
      pageh1: formLabelsData?.Key_MasterPage_1 || "CONFLICTS OF INTEREST",
      pageh2: formLabelsData?.Key_MasterPage_2 || "The Publicis way to Conduct Business with integrity | Code of Ethics Section 11.4 of Janus Volume I",
      menu1: formLabelsData?.Key_MasterPage_3 || "My Submission",
      menu2: formLabelsData?.Key_MasterPage_4 || "Logout",
      Pagetitle1: formLabelsData?.Key_MasterPage_5 || "My Submission",
      Pagetitle2: formLabelsData?.Key_MasterPage_6 || "My Submission",
      Pagetitle3: formLabelsData?.Key_MasterPage_7 || "ANNUAL SELF CERTIFICATION",
      Pagetitle4: formLabelsData?.Key_MasterPage_8 || "Submission Warning"
    }, Notice: {
      ButtonTitle1: formLabelsData?.Key29 || "I Agree"
    }
  });

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
  };

  const data = [
    { id: 1, company: "Intel Inside", details: "I have read the Policy set out on page 2 and list below all existing", date: "January 1, 2019" },
    { id: 1, company: "Intel Inside", details: "I have read the Policy set out on page 2 and list below all existing", date: "January 1, 2019" },
    { id: 1, company: "Intel Inside", details: "I have read the Policy set out on page 2 and list below all existing", date: "January 1, 2019" },
  ];

  const activeStyle = { backgroundColor: "#f5f5f5", color: "#000", padding: "10px", borderRadius: "0px" };
  const dataObject = {
    Language: values.Language.titel, // Correcting 'titel' to 'title' if needed
    LanguageCode: formLabelsData?.LanguageCode || "EN",

    // SubmissionPage
    Key_MySubmission_1: values.SubmissionPage.Title,
    Key_MySubmission_2: values.SubmissionPage.body,
    Key_MySubmission_3: values.SubmissionPage.ButtonTitle,
    Key_MySubmission_4: values.SubmissionPage.Statement,
    Key_MySubmission_5: values.SubmissionPage.CurrentStatus,
    Key_MySubmission_6: values.SubmissionPage.Submitted,
    Key_MySubmission_7: values.SubmissionPage.UnSubmitted,
    Key_MySubmission_8: values.SubmissionPage.UnBlock,
    Key_MySubmission_9: values.SubmissionPage.Year,
    Key_MySubmission_10: values.SubmissionPage.Location,
    Key_MySubmission_11: values.SubmissionPage.jobTitle,
    Key_MySubmission_12: values.SubmissionPage.hfmCode,
    Key_MySubmission_13: values.SubmissionPage.signOff,
    Key_MySubmission_16: values.SubmissionPage.status,


    // Step 1
    Key1: values.SubmissionFormTemplate.step1.Titel1,
    Key2: values.SubmissionFormTemplate.step1.Titel,
    Key40: values.SubmissionFormTemplate.step1.Titel2,
    Key23: values.SubmissionFormTemplate.step1.Warning,
    Key3: values.SubmissionFormTemplate.step1.EmployeeName,
    JoiningDate : values.SubmissionFormTemplate.step1.JoiningDate,
    Key4: values.SubmissionFormTemplate.step1.JobTitle,
    Key5: values.SubmissionFormTemplate.step1.company,
    Key6: values.SubmissionFormTemplate.step1.hfmCode,
    Key7: values.SubmissionFormTemplate.step1.aggrement,
    Key28: values.SubmissionFormTemplate.step1.ButtonTitle1,
    Key8: values.SubmissionFormTemplate.step1.ButtonTitle2,

    // Step 2
    Key9: values.SubmissionFormTemplate.step2.Titel,
    Key10: values.SubmissionFormTemplate.step2.aggrement,

    // Step 3
    Key11: values.SubmissionFormTemplate.step3.Titel,
    Key12: values.SubmissionFormTemplate.step3.selectNo,
    Key13: values.SubmissionFormTemplate.step3.selectYes,
    Key14: values.SubmissionFormTemplate.step3.aggrement,
    Key15: values.SubmissionFormTemplate.step3.tableh1,
    Key16: values.SubmissionFormTemplate.step3.tableh2,
    Key17: values.SubmissionFormTemplate.step3.tableh3,
    Key19: values.SubmissionFormTemplate.step3.aggrement1,
    Key18: values.SubmissionFormTemplate.step3.ButtonTitle3,

    // Step 4
    Key38: values.SubmissionFormTemplate.step4.titel,
    Key31: values.SubmissionFormTemplate.step4.aggrement,

    // Step 5
    Key30: values.SubmissionFormTemplate.step5.Titel,
    Key32: values.SubmissionFormTemplate.step5.selectNo,
    Key33: values.SubmissionFormTemplate.step5.selectYes,
    Key34: values.SubmissionFormTemplate.step5.aggrement,
    Key35: values.SubmissionFormTemplate.step5.tableh1,
    Key36: values.SubmissionFormTemplate.step5.tableh2,
    Key37: values.SubmissionFormTemplate.step5.tableh3,

    // Step 6
    Key20: values.SubmissionFormTemplate.step6.titel,
    Key21: values.SubmissionFormTemplate.step6.aggrement,
    Key22: values.SubmissionFormTemplate.step6.ButtonTitle2,
    // Key23:values.SubmissionFormTemplate.step6.

    // Submitted Page
    Key24: values.SubmittedPageTemplate.title,
    Key25: values.SubmittedPageTemplate.body,
    Key26: values.SubmittedPageTemplate.ButtonTitle1,
    Key27: values.SubmittedPageTemplate.ButtonTitle2,

    // Error Page
    Key_MySubmission_15: values.ErrorPage.title,

    // PDF Template
    Key_pdf_1: values.PdfTemplate.title1,
    Key_pdf_3: values.PdfTemplate.title2,
    Key_pdf_4: values.PdfTemplate.title3,
    Key_pdf_5: values.PdfTemplate.name,

    Key42: values.PdfTemplate.tableh1,
    Key43: values.PdfTemplate.tableh2,
    Key_pdf_11: values.PdfTemplate.signOff,
    Key_pdf_10: "Employee Name",
    Key_pdf_9: values.PdfTemplate.date,
    Key_pdf_8: values.PdfTemplate.aggrementTitel1,
    Key_pdf_12: values.PdfTemplate.aggrementTitel2,

    // Master Page
    Key_MasterPage_1: values.MasterPage.pageh1,
    Key_MasterPage_2: values.MasterPage.pageh2,
    Key_MasterPage_3: values.MasterPage.menu1,
    Key_MasterPage_4: values.MasterPage.menu2,
    Key_MasterPage_5: values.MasterPage.Pagetitle1,
    Key_MasterPage_6: values.MasterPage.Pagetitle2,
    Key_MasterPage_7: values.MasterPage.Pagetitle3,
    Key_MasterPage_8: values.MasterPage.Pagetitle4,

    // Notice
    Key29: values.Notice.ButtonTitle1,
    IsActive: true
  };

  if (formLabelsData) {
    dataObject.ID = formLabelsData.ID;
  }

  const handleSubmit = () => {
    dispatch(SaveFormLabels(dataObject)).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setAlert(true);
        setSavirity("success");
        setMessage(res?.payload?.data[0]?.success)
        setTimeout(() => {
          navigate(`/app-vcoi/vcoisitecontent/VcoiManageFormLabels`)
        }, 1000)
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setSavirity("error");
        setMessage(res?.payload?.data[0]?.error)
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSavirity("error");
      }
    })
  }

  return (
    <>
      <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <div className="headerNavigation">
        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
          {
            formLabelsData.id ? 'Edit Form Labels' : 'Add Form Labels'
          }
          
        </Typography>
        <Typography
          sx={{
            display: "flex", // Align icon and text horizontally
            alignItems: "center", // Vertically center icon and text
            fontSize: "12px",
            color: "#212129",
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
              color: "#212129",
            },
          }}
          onClick={() => {
            navigate(`/app-vcoi/vcoisitecontent/VcoiManageFormLabels`);
          }}
        >
          <ArrowBackIosIcon sx={{ fontSize: "inherit", mr: 0.5 }} /> {/* Adjust icon size */}
          back to list
        </Typography>

      </div>
      <Box className="boxAlignmentForm">
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} sm={8} md={12} m={4} >
            <Typography sx={{ fontWeight: "bold", margin: "10px 0px" }}>Language</Typography>
            <InputControl placeholder="Type a language e.g. English(UK),Francois etc" value={values.Language.titel} onChange={(e) => setValues(prevValues => ({
              ...prevValues,
              Language: {
                ...prevValues.Language,
                titel: e
              }
            }))} />
            <Grid my={2} sx={{ display: "flex", justifyContent: "flex-start" }}><InfoIcon /> <Typography sx={{ margin: "1px 5px" }}>The language name is used for multiple languages selection. It should be native language.</Typography></Grid>
          </Grid>
        </Grid>
      </Box>
      <Box className="boxAlignmentMenu">
        <Grid container spacing={0} alignItems="center" justifyContent="space-between">
          {["SUBMISSION PAGE", "SUBMISSION FORM TEMPLATE", "SUBMITTED PAGE TEMPLATE", "PDF TEMPLATE", "ERROR PAGE", "MASTER PAGE", "PRIVACY NOTICE"].map((menu) => (
            <Grid
              item
              key={menu}
              md="auto"
              sx={{
                ...menu === activeMenu ? activeStyle : { padding: "5px" },
                padding: "10px",
                borderRadius: "20px",
                cursor: "pointer", // Add cursor pointer for hover effect
                color: menu === activeMenu ? "white" : "#212129", // Conditional color styling
                fontWeight: menu === activeMenu ? "600" : "normal", // Optional: Make active menu bold
                backgroundColor: menu === activeMenu ? "#212129" : "",
              }}
              onClick={() => handleMenuClick(menu)}
            >
              <Typography>{menu}</Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
      {activeMenu === "SUBMISSION PAGE" ? <Box sx={{ margin: "20px 40px", padding: "20px", backgroundColor: "#F6F7FA" }}>
        <Grid
          container
          alignItems="center" spacing={2}
        >
          <Grid item xs={12} sm={6} md={10}>
            {!isEditing1 ? (
              <Box sx={{
                backgroundColor: '#E7E7E7',
                padding: "15px",
                borderRadius: 0
              }} onClick={() => setIsEditing1(true)} >
                {values.SubmissionPage.Title}
              </Box>
            ) : (
              <InputControl
                // className="customInput"
                placeholder="New Conflict of Interest Disclosure Statement is sent to you. You are required to sign-off 'Conflict Interest Disclosure Statement'"
                value={values.SubmissionPage.Title}
                onChange={(e) => setValues(prevValues => ({
                  ...prevValues,
                  SubmissionPage: {
                    ...prevValues.SubmissionPage,
                    Title: e
                  }
                }))} // Capture input changes
              />
            )}

          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            {!isEditing2 ? (
              <Button sx={{
                backgroundColor: '#212129',
                borderRadius: "25px",
              }} onClick={() => setIsEditing2(true)} variant="contained">
                {values.SubmissionPage.ButtonTitle}
              </Button>
            ) : (
              <InputControl
                value={values.SubmissionPage.ButtonTitle}
                onChange={(e) => setValues(prevValues => ({
                  ...prevValues,
                  SubmissionPage: {
                    ...prevValues.SubmissionPage,
                    ButtonTitle: e
                  }
                }))}
                placeholder="Enter text..."
                autoFocus
              />
            )}
          </Grid>

          <Grid item
            xs={12}
            sm={8}
            md={12}>
            {!isEditing3 ? (
              <Box sx={{
                border: "1px solid gray", borderRadius: "5px", padding: "10px"
              }} onClick={() => setIsEditing3(true)} variant="contained">
                {values.SubmissionPage.Statement}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.Statement} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  Statement: e
                }
              }))} placeholder="Your Conflict of Interest Disclosure Statements" />
            )}

          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            {!isEditing4 ? (
              <Box sx={{
                border: "1px solid #337ABF", borderRadius: "5px", padding: "10px", color: "#337ABF", fontWeight: 600
              }} onClick={() => setIsEditing4(true)} variant="contained">
                {values.SubmissionPage.CurrentStatus}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.CurrentStatus} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  CurrentStatus: e
                }
              }))} placeholder="CURRENT STATUS" />
            )}

          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            {!isEditing5 ? (
              <Box sx={{
                border: "1px solid green", borderRadius: "5px", padding: "10px", color: "green", fontWeight: 600
              }} onClick={() => setIsEditing5(true)} variant="contained">
                {values.SubmissionPage.Submitted}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.Submitted} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  Submitted: e
                }
              }))} placeholder="SUBMITTED" />
            )}
            {/* <button className="customStatusButton">SUBMITTED</button> */}
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            {!isEditing6 ? (
              <Box sx={{
                border: "1px solid red", color: "red", borderRadius: "5px", padding: "10px", fontWeight: 600
              }} onClick={() => setIsEditing6(true)} variant="contained">
                {values.SubmissionPage.UnSubmitted}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.UnSubmitted} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  UnSubmitted: e
                }
              }))} placeholder="UNSUBMITTED" />
            )}

          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            {!isEditing7 ? (
              <Box sx={{
                border: "1px solid #FD9200", borderRadius: "5px", padding: "10px", color: "#FD9200", fontWeight: 600
              }} onClick={() => setIsEditing7(true)} variant="contained">
                {values.SubmissionPage.UnBlock}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.UnBlock} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  UnBlock: e
                }
              }))} placeholder="UNBLOCKED" />
            )}

          </Grid>

          <Grid item xs={12} sm={2} md={2} sx={{ marginRight: "0px" }}>
            {!isEditing8 ? (
              <Box sx={{
                border: "1px solid gray", borderRadius: "5px", padding: "10px"
              }} onClick={() => setIsEditing8(true)} variant="contained">
                {values.SubmissionPage.Year}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.Year} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  Year: e
                }
              }))} placeholder="Year" />
            )}

          </Grid>
          <Grid item xs={12} sm={2} md={2} sx={{ marginRight: "0px" }}>
            {!isEditing9 ? (
              <Box sx={{
                border: "1px solid gray", borderRadius: "5px", padding: "10px"
              }} onClick={() => setIsEditing9(true)} variant="contained">
                {values.SubmissionPage.Location}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.Location} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  Location: e
                }
              }))} placeholder="Location" />
            )}

          </Grid>
          <Grid item xs={12} sm={2} md={2} sx={{ marginRight: "0px" }}>
            {!isEditing10 ? (
              <Box sx={{
                border: "1px solid gray", borderRadius: "5px", padding: "10px"
              }} onClick={() => setIsEditing10(true)} variant="contained">
                {values.SubmissionPage.jobTitle}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.jobTitle} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  jobTitle: e
                }
              }))} placeholder="Job Title" />
            )}

          </Grid>
          <Grid item xs={12} sm={2} md={2} sx={{ marginRight: "0px" }}>
            {!isEditing11 ? (
              <Box sx={{
                border: "1px solid gray", borderRadius: "5px", padding: "10px"
              }} onClick={() => setIsEditing11(true)} variant="contained">
                {values.SubmissionPage.hfmCode}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.hfmCode} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  hfmCode: e
                }
              }))} placeholder="HFM Code" />
            )}

          </Grid>
          <Grid item xs={12} sm={2} md={2}>
            {!isEditing12 ? (
              <Box sx={{
                border: "1px solid gray", borderRadius: "5px", padding: "10px"
              }} onClick={() => setIsEditing12(true)} variant="contained">
                {values.SubmissionPage.signOff}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.signOff} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  signOff: e
                }
              }))} placeholder="Sign Off" />
            )}

          </Grid>
          <Divider sx={{ padding: "0.5px", backgroundColor: "lightgray" }} />
          <Grid item
            xs={12}
            sm={8}
            md={12}>
            {!isEditing13 ? (
              <Box sx={{
                border: "1px solid gray", borderRadius: "5px", padding: "10px"
              }} onClick={() => setIsEditing13(true)} variant="contained">
                {values.SubmissionPage.status}
              </Box>
            ) : (
              <InputControl value={values.SubmissionPage.status} onChange={(e) => setValues(prevValues => ({
                ...prevValues,
                SubmissionPage: {
                  ...prevValues.SubmissionPage,
                  status: e
                }
              }))} placeholder="You do not have any active submission." />
            )}
          </Grid>

        </Grid>

        <Divider sx={{ padding: "0.5px", backgroundColor: "lightgray" }} />

      </Box> : ""}

      {
        activeMenu === "SUBMISSION FORM TEMPLATE" ?
          <Box sx={{ margin: "20px 40px", padding: "20px", backgroundColor: "#F6F7FA" }}>
            <Grid alignItems="center">
              <Grid item xs={12} sm={6} md={12} mb={2}>
                {!isEditing14 ? (
                  <Box sx={{
                    border: "1px solid gray", borderRadius: "5px", padding: "10px"
                  }} onClick={() => setIsEditing14(true)} variant="contained">
                    {values.SubmissionFormTemplate.step1.Titel1}
                  </Box>
                ) : (
                  <textarea
                    className="manageWidth"
                    value={values.SubmissionFormTemplate.step1.Titel1}  // Ensure key matches exactly
                    onChange={(e) =>
                      setValues((prevValues) => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step1: {
                            ...prevValues.SubmissionFormTemplate.step1,
                            Titel1: e.target.value,  // Ensure key matches exactly
                          },
                        },
                      }))
                    }
                  />
                )}


              </Grid>
              <Grid item xs={12} sm={12} md={12} my={2}>
                <StepHeader>
                  <StepNumber>1</StepNumber>
                  {!isEditing15 ? (
                    <Box sx={{
                      border: "1px solid gray", borderRadius: "5px", padding: "10px"
                    }} onClick={() => setIsEditing15(true)} variant="contained">
                      {values.SubmissionFormTemplate.step1.Titel}
                    </Box>
                  ) : (
                    <InputControl value={values.SubmissionFormTemplate.step1.Titel}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step1: {
                            ...prevValues.SubmissionFormTemplate.step1,
                            Titel: e
                          }
                        }
                      }))} className="manageWidth" variant="outlined" />
                  )}

                </StepHeader>
                <Grid item xs={12} sm={6} md={12} mb={2}>
                  {!isEditing16 ? (
                    <Box sx={{
                      border: "1px solid gray", borderRadius: "5px", padding: "10px"
                    }} onClick={() => setIsEditing16(true)} variant="contained">
                      {values.SubmissionFormTemplate.step1.Titel2}
                    </Box>
                  ) : (
                    <textarea
                      className="manageWidth"
                      // id="outlined--flexible"
                      
                      // maxRows={3}
                      value={values.SubmissionFormTemplate.step1.Titel2}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step1: {
                            ...prevValues.SubmissionFormTemplate.step1,
                            Titel2: e.target.value
                          }
                        }
                      }))}
                    />
                  )}

                  <Grid container spacing={2} mt={2}>
                    <Grid item xs={12} sm={12} >
                      {!isEditing181 ? (
                        <Box sx={{display:"flex",alignItems:"center",
                          border: "1px solid gray", borderRadius: "5px", padding: "10px", backgroundColor: "#E7E7E7"
                        }} onClick={() => setIsEditing181(true)} variant="contained">
                          <WarningIcon/>{values.SubmissionFormTemplate.step1.Warning}
                        </Box>
                      ) : (
                        <InputControl value={values.SubmissionFormTemplate.step1.Warning}
                          onChange={(e) => setValues(prevValues => ({
                            ...prevValues,
                            SubmissionFormTemplate: {
                              ...prevValues.SubmissionFormTemplate,
                              step1: {
                                ...prevValues.SubmissionFormTemplate.step1,
                                Warning: e
                              }
                            }
                          }))} />
                      )}

                    </Grid>
                    <Grid item xs={12} sm={6} >
                      {!isEditing17 ? (
                        <Box sx={{
                          border: "1px solid gray", borderRadius: "5px", padding: "10px"
                        }} onClick={() => setIsEditing17(true)} variant="contained">
                          {values.SubmissionFormTemplate.step1.EmployeeName}
                        </Box>
                      ) : (
                        <InputControl value={values.SubmissionFormTemplate.step1.EmployeeName}
                          onChange={(e) => setValues(prevValues => ({
                            ...prevValues,
                            SubmissionFormTemplate: {
                              ...prevValues.SubmissionFormTemplate,
                              step1: {
                                ...prevValues.SubmissionFormTemplate.step1,
                                EmployeeName: e
                              }
                            }
                          }))} placeholder="Employee Name" />
                      )}

                    </Grid>

                    <Grid item xs={12} sm={6} >
                      {!isEditing18 ? (
                        <Box sx={{
                          border: "1px solid gray", borderRadius: "5px", padding: "10px"
                        }} onClick={() => setIsEditing18(true)} variant="contained">
                          {values.SubmissionFormTemplate.step1.JobTitle}
                        </Box>
                      ) : (
                        <InputControl value={values.SubmissionFormTemplate.step1.JobTitle}
                          onChange={(e) => setValues(prevValues => ({
                            ...prevValues,
                            SubmissionFormTemplate: {
                              ...prevValues.SubmissionFormTemplate,
                              step1: {
                                ...prevValues.SubmissionFormTemplate.step1,
                                JobTitle: e
                              }
                            }
                          }))} placeholder="Job Title" />
                      )}

                    </Grid>
                    
                    <Grid item xs={12} sm={6} >
                      {!isEditing83 ? (
                        <Box sx={{
                          border: "1px solid gray", borderRadius: "5px", padding: "10px"
                        }} onClick={() => setIsEditing83(true)} variant="contained">
                          {values.SubmissionFormTemplate.step1.JoiningDate}

                        </Box>
                      ) : (
                        <InputControl value={values.SubmissionFormTemplate.step1.JoiningDate}
                          onChange={(e) => setValues(prevValues => ({
                            ...prevValues,
                            SubmissionFormTemplate: {
                              ...prevValues.SubmissionFormTemplate,
                              step1: {
                                ...prevValues.SubmissionFormTemplate.step1,
                                JoiningDate: e
                              }
                            }
                          }))} placeholder="Joining Date" />
                      )}

                    </Grid>


                    <Grid item xs={12} sm={6}>
                      {!isEditing19 ? (
                        <Box sx={{
                          border: "1px solid gray", borderRadius: "5px", padding: "10px"
                        }} onClick={() => setIsEditing19(true)} variant="contained">
                          {values.SubmissionFormTemplate.step1.company}
                        </Box>
                      ) : (
                        <InputControl value={values.SubmissionFormTemplate.step1.company}
                          onChange={(e) => setValues(prevValues => ({
                            ...prevValues,
                            SubmissionFormTemplate: {
                              ...prevValues.SubmissionFormTemplate,
                              step1: {
                                ...prevValues.SubmissionFormTemplate.step1,
                                company: e
                              }
                            }
                          }))} placeholder="Company" />
                      )}

                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {!isEditing20 ? (
                        <Box sx={{
                          border: "1px solid gray", borderRadius: "5px", padding: "10px"
                        }} onClick={() => setIsEditing20(true)} variant="contained">
                          {values.SubmissionFormTemplate.step1.hfmCode}
                        </Box>
                      ) : (
                        <InputControl value={values.SubmissionFormTemplate.step1.hfmCode}
                          onChange={(e) => setValues(prevValues => ({
                            ...prevValues,
                            SubmissionFormTemplate: {
                              ...prevValues.SubmissionFormTemplate,
                              step1: {
                                ...prevValues.SubmissionFormTemplate.step1,
                                hfmCode: e
                              }
                            }
                          }))} placeholder="HFM Code" />
                      )}

                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} mt={2}>
                    {!isEditing21 ? (
                      <Box sx={{
                        border: "1px solid gray", borderRadius: "5px", padding: "10px"
                      }} onClick={() => setIsEditing21(true)} variant="contained">
                        {values.SubmissionFormTemplate.step1.aggrement}
                      </Box>
                    ) : (
                      <InputControl
                        value={values.SubmissionFormTemplate.step1.aggrement}
                        onChange={(e) => setValues(prevValues => ({
                          ...prevValues,
                          SubmissionFormTemplate: {
                            ...prevValues.SubmissionFormTemplate,
                            step1: {
                              ...prevValues.SubmissionFormTemplate.step1,
                              aggrement: e
                            }
                          }
                        }))}
                        className="manageWidth"
                        
                      />
                    )}

                  </Grid>
                  <Grid item xs={12} sm={8} md={6} mt={2} sx={{ display: "flex" }}>
                    {!isEditing22 ? (
                      <Button sx={{
                        backgroundColor: 'lightGray',
                        borderRadius: "25px",
                      }} onClick={() => setIsEditing22(true)} variant="contained">
                        {values.SubmissionFormTemplate.step1.ButtonTitle1}
                      </Button>
                    ) : (
                      <InputControl
                        value={values.SubmissionFormTemplate.step1.ButtonTitle1}
                        onChange={(e) => setValues(prevValues => ({
                          ...prevValues,
                          SubmissionFormTemplate: {
                            ...prevValues.SubmissionFormTemplate,
                            step1: {
                              ...prevValues.SubmissionFormTemplate.step1,
                              ButtonTitle1: e
                            }
                          }
                        }))}
                        placeholder="Enter text..."
                        autoFocus
                      />
                    )} &nbsp;
                    {!isEditing23 ? (
                      <Button sx={{
                        backgroundColor: '#212129',
                        borderRadius: "25px",
                      }} onClick={() => setIsEditing23(true)} variant="contained">
                        {values.SubmissionFormTemplate.step1.ButtonTitle2}
                      </Button>
                    ) : (
                      <InputControl
                        value={values.SubmissionFormTemplate.step1.ButtonTitle2}
                        onChange={(e) => setValues(prevValues => ({
                          ...prevValues,
                          SubmissionFormTemplate: {
                            ...prevValues.SubmissionFormTemplate,
                            step1: {
                              ...prevValues.SubmissionFormTemplate.step1,
                              ButtonTitle2: e
                            }
                          }
                        }))}
                        placeholder="Enter text..."
                        autoFocus
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Divider />


            <Grid container alignItems="center" spacing={4} my={2}>
              <Grid item xs={12} sm={12} md={12}>
                <StepHeader>
                  <StepNumber>2</StepNumber>
                  {!isEditing24 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing24(true)} variant="contained">
                      {values.SubmissionFormTemplate.step2.Titel}
                    </Box>
                  ) : (
                    <InputControl value={values.SubmissionFormTemplate.step2.Titel}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step2: {
                            ...prevValues.SubmissionFormTemplate.step2,
                            Titel: e
                          }
                        }
                      }))} className="manageWidth" variant="outlined" />
                  )}

                </StepHeader>
                <Grid item xs={12} sm={6} md={6} mt={2} m={2} sx={{display:"flex",alignItems:"center",fontSize:"12px"}}>
                {`<`}<WarningIcon/>&nbsp;Policy content area{`>`}
                </Grid>
                <Grid item xs={12} sm={6} md={6} mt={2} m={2}>
                  {!isEditing25 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing25(true)} variant="contained">
                      {values.SubmissionFormTemplate.step2.aggrement}
                    </Box>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step2.aggrement}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step2: {
                            ...prevValues.SubmissionFormTemplate.step2,
                            aggrement: e
                          }
                        }
                      }))}
                      className="manageWidth"
                    />
                  )}

                </Grid>
                <Grid item xs={12} sm={8} md={6} mt={2} sx={{ display: "flex" }}>
                  {!isEditing26 ? (
                    <Button sx={{
                      backgroundColor: 'lightGray',
                      borderRadius: "25px"
                    }} onClick={() => setIsEditing26(true)} variant="contained">
                      {values.SubmissionFormTemplate.step2.ButtonTitle1}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step2.ButtonTitle1}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step2: {
                            ...prevValues.SubmissionFormTemplate.step2,
                            ButtonTitle1: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )} &nbsp;
                  {!isEditing27 ? (
                    <Button sx={{
                      backgroundColor: '#212129',
                      borderRadius: "25px"
                    }} onClick={() => setIsEditing27(true)} variant="contained">
                      {values.SubmissionFormTemplate.step2.ButtonTitle2}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step2.ButtonTitle2}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step2: {
                            ...prevValues.SubmissionFormTemplate.step2,
                            ButtonTitle2: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}
                </Grid>

              </Grid>
            </Grid>
            <Divider />
            <Grid container alignItems="center" spacing={4} my={2}>
              <Grid item xs={12} sm={12} md={12}>
                <StepHeader>
                  <StepNumber>3</StepNumber>
                  {!isEditing28 ? (
                    <Box sx={{
                      border: "1px solid gray", borderRadius: "5px", padding: "10px"
                    }} onClick={() => setIsEditing28(true)} variant="contained">
                      {values.SubmissionFormTemplate.step3.Titel}
                    </Box>
                  ) : (
                    <InputControl value={values.SubmissionFormTemplate.step3.Titel}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step3: {
                            ...prevValues.SubmissionFormTemplate.step3,
                            Titel: e
                          }
                        }
                      }))} className="manageWidth" variant="outlined" />
                  )}

                </StepHeader>
                <Grid item xs={12} sm={6} md={6} mt={2} m={2}>
                  {!isEditing29 ? (
                    <Box sx={{
                      border: "1px solid gray", borderRadius: "5px", padding: "10px"
                    }} onClick={() => setIsEditing29(true)} variant="contained">
                      {values.SubmissionFormTemplate.step3.selectNo}
                    </Box>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step3.selectNo}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step3: {
                            ...prevValues.SubmissionFormTemplate.step3,
                            selectNo: e
                          }
                        }
                      }))}
                      className="manageWidth"
                    />
                  )}

                </Grid>
                <Grid item xs={12} sm={6} md={6} mt={2} m={2}>
                  {!isEditing30 ? (
                    <Box sx={{
                      border: "1px solid gray", borderRadius: "5px", padding: "10px"
                    }} onClick={() => setIsEditing30(true)} variant="contained">
                      {values.SubmissionFormTemplate.step3.selectYes}
                    </Box>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step3.selectYes}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step3: {
                            ...prevValues.SubmissionFormTemplate.step3,
                            selectYes: e
                          }
                        }
                      }))}
                      className="manageWidth"
                    />
                  )}

                </Grid>
                <Grid item xs={12} sm={12} md={12} mt={2} m={2}>
                  <Box sx={{ padding: "10px", border: "1px solid #212129" }}>
                    {!isEditing31 ? (
                      <Box sx={{
                        border: "1px solid gray", borderRadius: "5px", padding: "10px"
                      }} onClick={() => setIsEditing31(true)} variant="contained">
                        {values.SubmissionFormTemplate.step3.aggrement}
                      </Box>
                    ) : (
                      <InputControl
                        value={values.SubmissionFormTemplate.step3.aggrement}
                        onChange={(e) => setValues(prevValues => ({
                          ...prevValues,
                          SubmissionFormTemplate: {
                            ...prevValues.SubmissionFormTemplate,
                            step3: {
                              ...prevValues.SubmissionFormTemplate.step3,
                              aggrement: e
                            }
                          }
                        }))}
                        className="manageWidth"
                      />
                    )}

                    <Grid container spacing={1} sx={{ padding: "5px" }}>
                      <Grid item xs={12} sm={12} md={1}>
                        {!isEditing32 ? (
                          <Box sx={{
                            border: "1px solid gray", borderRadius: "5px", padding: "10px"
                          }} onClick={() => setIsEditing32(true)} variant="contained">
                            {values.SubmissionFormTemplate.step3.index}
                          </Box>
                        ) : (
                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step3.index}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step3: {
                                  ...prevValues.SubmissionFormTemplate.step3,
                                  index: e
                                }
                              }
                            }))}
                          />
                        )}

                      </Grid>
                      <Grid item xs={12} sm={12} md={3}>
                        {!isEditing33 ? (
                          <Box sx={{
                            border: "1px solid gray", borderRadius: "5px", padding: "10px"
                          }} onClick={() => setIsEditing33(true)} variant="contained">
                            {values.SubmissionFormTemplate.step3.tableh1}
                          </Box>
                        ) : (

                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step3.tableh1}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step3: {
                                  ...prevValues.SubmissionFormTemplate.step3,
                                  tableh1: e
                                }
                              }
                            }))}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={12} md={3}>
                        {!isEditing34 ? (
                          <Box sx={{
                            border: "1px solid gray", borderRadius: "5px", padding: "10px"
                          }} onClick={() => setIsEditing34(true)} variant="contained">
                            {values.SubmissionFormTemplate.step3.tableh2}
                          </Box>
                        ) : (
                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step3.tableh2}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step3: {
                                  ...prevValues.SubmissionFormTemplate.step3,
                                  tableh2: e
                                }
                              }
                            }))}
                          />
                        )}

                      </Grid>
                      <Grid item xs={12} sm={12} md={3}>
                        {!isEditing84 ? (
                          <Box sx={{
                            border: "1px solid gray", borderRadius: "5px", padding: "10px"
                          }} onClick={() => setIsEditing33(true)} variant="contained">
                            {values.SubmissionFormTemplate.step3.tableh3}
                          </Box>
                        ) : (

                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step3.tableh3}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step3: {
                                  ...prevValues.SubmissionFormTemplate.step3,
                                  tableh3: e
                                }
                              }
                            }))}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} m={1} sx={{ display: "flex", justifyContent: "right" }}>
                        {!isEditing35 ? (
                          <Button sx={{
                            backgroundColor: '#212129',
                            borderRadius: "20px"
                          }} onClick={() => setIsEditing35(true)} variant="contained">
                            {values.SubmissionFormTemplate.step3.ButtonTitle3}
                          </Button>
                        ) : (
                          <InputControl
                            value={values.SubmissionFormTemplate.step3.ButtonTitle3}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step3: {
                                  ...prevValues.SubmissionFormTemplate.step3,
                                  ButtonTitle3: e
                                }
                              }
                            }))}
                            placeholder="Enter text..."
                            autoFocus
                          />
                        )}
                      </Grid>
                    </Grid>

                  </Box>
                  <Grid item xs={12} sm={12} md={12} m={1} >
                    {!isEditing36 ? (
                      <Box sx={{
                        borderRadius: "5px",
                        padding: "10px",
                        border: "1px solid gray"
                      }} onClick={() => setIsEditing36(true)} variant="contained">
                        {values.SubmissionFormTemplate.step3.aggrement1}
                      </Box>
                    ) : (
                      <InputControl
                        className="manageWidth"
                        value={values.SubmissionFormTemplate.step3.aggrement1}
                        onChange={(e) => setValues(prevValues => ({
                          ...prevValues,
                          SubmissionFormTemplate: {
                            ...prevValues.SubmissionFormTemplate,
                            step3: {
                              ...prevValues.SubmissionFormTemplate.step3,
                              aggrement1: e
                            }
                          }
                        }))}
                      />
                    )}

                  </Grid>
                </Grid>
                <Grid item xs={12} sm={8} md={6} mt={2} sx={{ display: "flex" }}>
                  {!isEditing37 ? (
                    <Button sx={{
                      backgroundColor: 'lightGray',
                      borderRadius: "20px"
                    }} onClick={() => setIsEditing37(true)} variant="contained">
                      {values.SubmissionFormTemplate.step3.ButtonTitle1}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step3.ButtonTitle1}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step3: {
                            ...prevValues.SubmissionFormTemplate.step2,
                            ButtonTitle1: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}&nbsp;
                  {!isEditing38 ? (
                    <Button sx={{
                      backgroundColor: '#212129',
                      borderRadius: "20px"
                    }} onClick={() => setIsEditing38(true)} variant="contained">
                      {values.SubmissionFormTemplate.step3.ButtonTitle2}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step3.ButtonTitle2}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step3: {
                            ...prevValues.SubmissionFormTemplate.step3,
                            ButtonTitle2: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}

                </Grid>
              </Grid>
            </Grid>
            {/* <Divider />
            <Grid container alignItems="center" spacing={4} my={2}>
              <Grid item xs={12} sm={12} md={12}>
                <StepHeader>
                  <StepNumber>4</StepNumber>
                  {!isEditing39 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing39(true)} variant="contained">
                      {values.SubmissionFormTemplate.step4.titel}
                    </Box>
                  ) : (
                    <InputControl value={values.SubmissionFormTemplate.step4.titel}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step4: {
                            ...prevValues.SubmissionFormTemplate.step4,
                            titel: e
                          }
                        }
                      }))} className="manageWidth" variant="outlined" />
                  )}

                </StepHeader>

                <Grid item xs={12} sm={6} md={6} mt={2} m={2} sx={{display:"flex",alignItems:"center",fontSize:"12px"}}>
                {`<`}<WarningIcon/>&nbsp;Policy content area{`>`}
                </Grid>
                
                <Grid item xs={12} sm={6} md={6} mt={2} m={2}>
                  {!isEditing40 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing40(true)} variant="contained">
                      {values.SubmissionFormTemplate.step4.aggrement}
                    </Box>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step4.aggrement}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step4: {
                            ...prevValues.SubmissionFormTemplate.step4,
                            aggrement: e
                          }
                        }
                      }))}
                      className="manageWidth"
                    />
                  )}

                </Grid>
                <Grid item xs={12} sm={8} md={6} mt={2} sx={{ display: "flex" }}>
                  {!isEditing41 ? (
                    <Button sx={{
                      backgroundColor: 'lightGray',
                      borderRadius: "20px"
                    }} onClick={() => setIsEditing41(true)} variant="contained">
                      {values.SubmissionFormTemplate.step4.ButtonTitle1}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step4.ButtonTitle1}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step4: {
                            ...prevValues.SubmissionFormTemplate.step4,
                            ButtonTitle1: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}&nbsp;
                  {!isEditing42 ? (
                    <Button sx={{
                      backgroundColor: '#212129',
                      borderRadius: "20px"
                    }} onClick={() => setIsEditing42(true)} variant="contained">
                      {values.SubmissionFormTemplate.step4.ButtonTitle2}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step4.ButtonTitle2}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step4: {
                            ...prevValues.SubmissionFormTemplate.step2,
                            ButtonTitle2: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}
                </Grid>
              </Grid>
            </Grid> */}
            {/* <Divider />
            <Grid container alignItems="center" spacing={4} my={2}>
              <Grid item xs={12} sm={12} md={12}>
                <StepHeader>
                  <StepNumber>5</StepNumber>
                  {!isEditing43 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing43(true)} variant="contained">
                      {values.SubmissionFormTemplate.step5.Titel}
                    </Box>
                  ) : (
                    <InputControl value={values.SubmissionFormTemplate.step5.Titel}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step5: {
                            ...prevValues.SubmissionFormTemplate.step5,
                            Titel: e
                          }
                        }
                      }))} className="manageWidth" variant="outlined" />
                  )}

                </StepHeader>
                <Grid item xs={12} sm={6} md={6} mt={2} m={2}>
                  {!isEditing44 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing44(true)} variant="contained">
                      {values.SubmissionFormTemplate.step5.selectNo}
                    </Box>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step5.selectNo}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step5: {
                            ...prevValues.SubmissionFormTemplate.step5,
                            selectNo: e
                          }
                        }
                      }))}
                      className="manageWidth"
                    />
                  )}

                </Grid>
                <Grid item xs={12} sm={6} md={6} mt={2} m={2}>
                  {!isEditing45 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing45(true)} variant="contained">
                      {values.SubmissionFormTemplate.step5.selectYes}
                    </Box>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step5.selectYes}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step5: {
                            ...prevValues.SubmissionFormTemplate.step5,
                            selectYes: e
                          }
                        }
                      }))}
                      className="manageWidth"

                    />
                  )}

                </Grid>
                <Grid item xs={12} sm={12} md={12} mt={2} m={2}>
                  <Box sx={{ padding: "10px", border: "1px solid #212129" }}>
                    {!isEditing46 ? (
                      <Box sx={{
                        borderRadius: "5px",
                        padding: "10px",
                        border: "1px solid gray"
                      }} onClick={() => setIsEditing46(true)} variant="contained">
                        {values.SubmissionFormTemplate.step5.aggrement}
                      </Box>
                    ) : (
                      <InputControl
                        value={values.SubmissionFormTemplate.step5.aggrement}
                        onChange={(e) => setValues(prevValues => ({
                          ...prevValues,
                          SubmissionFormTemplate: {
                            ...prevValues.SubmissionFormTemplate,
                            step5: {
                              ...prevValues.SubmissionFormTemplate.step5,
                              aggrement: e
                            }
                          }
                        }))}
                        className="manageWidth"
                      />
                    )}

                    <Grid container spacing={1} sx={{ padding: "5px" }}>
                      <Grid item xs={12} sm={12} md={1}>
                        {!isEditing47 ? (
                          <Box sx={{
                            borderRadius: "5px",
                            padding: "10px",
                            border: "1px solid gray"
                          }} onClick={() => setIsEditing47(true)} variant="contained">
                            {values.SubmissionFormTemplate.step5.index}
                          </Box>
                        ) : (
                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step5.index}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step5: {
                                  ...prevValues.SubmissionFormTemplate.step5,
                                  index: e
                                }
                              }
                            }))}
                          />
                        )}

                      </Grid>
                      <Grid item xs={12} sm={12} md={3}>
                        {!isEditing48 ? (
                          <Box sx={{
                            borderRadius: "5px",
                            padding: "10px",
                            border: "1px solid gray"
                          }} onClick={() => setIsEditing48(true)} variant="contained">
                            {values.SubmissionFormTemplate.step5.tableh1}
                          </Box>
                        ) : (
                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step5.tableh1}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step5: {
                                  ...prevValues.SubmissionFormTemplate.step5,
                                  tableh1: e
                                }
                              }
                            }))}
                          />
                        )}

                      </Grid>
                      <Grid item xs={12} sm={12} md={4}>
                        {!isEditing49 ? (
                          <Box sx={{
                            borderRadius: "5px",
                            padding: "10px",
                            border: "1px solid gray"
                          }} onClick={() => setIsEditing49(true)} variant="contained">
                            {values.SubmissionFormTemplate.step5.tableh2}
                          </Box>
                        ) : (
                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step5.tableh2}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step5: {
                                  ...prevValues.SubmissionFormTemplate.step5,
                                  tableh2: e
                                }
                              }
                            }))}
                          />
                        )}

                      </Grid>
                      <Grid item xs={12} sm={12} md={4}>
                        {!isEditing50 ? (
                          <Box sx={{
                            borderRadius: "5px",
                            padding: "10px",
                            border: "1px solid gray"
                          }} onClick={() => setIsEditing50(true)} variant="contained">
                            {values.SubmissionFormTemplate.step5.tableh3}
                          </Box>
                        ) : (
                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step5.tableh3}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step5: {
                                  ...prevValues.SubmissionFormTemplate.step5,
                                  tableh3: e
                                }
                              }
                            }))}
                          />
                        )}

                      </Grid>
                      <Grid item xs={12} sm={12} md={12} m={1} sx={{ display: "flex", justifyContent: "right" }}>
                        {!isEditing51 ? (
                          <Button onClick={() => setIsEditing51(true)} sx={{ backgroundColor: "#212129", borderRadius: "20px", color: "white" }}>{values.SubmissionFormTemplate.step5.ButtonTitle3}</Button>
                        ) : (
                          <InputControl
                            className="manageWidth"
                            value={values.SubmissionFormTemplate.step5.ButtonTitle3}
                            onChange={(e) => setValues(prevValues => ({
                              ...prevValues,
                              SubmissionFormTemplate: {
                                ...prevValues.SubmissionFormTemplate,
                                step5: {
                                  ...prevValues.SubmissionFormTemplate.step5,
                                  ButtonTitle3: e
                                }
                              }
                            }))}
                          />
                        )}

                      </Grid>
                    </Grid>

                  </Box>
                </Grid>
                <Grid item xs={12} sm={8} md={6} mt={2} sx={{ display: "flex" }}>
                  {!isEditing52 ? (
                    <Button sx={{
                      backgroundColor: 'lightGray',
                      borderRadius: "20px"
                    }} onClick={() => setIsEditing52(true)} variant="contained">
                      {values.SubmissionFormTemplate.step5.ButtonTitle1}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step5.ButtonTitle1}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step5: {
                            ...prevValues.SubmissionFormTemplate.step5,
                            ButtonTitle1: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}&nbsp;
                  {!isEditing53 ? (
                    <Button sx={{
                      backgroundColor: '#212129',
                      borderRadius: "20px"
                    }} onClick={() => setIsEditing53(true)} variant="contained">
                      {values.SubmissionFormTemplate.step5.ButtonTitle2}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step5.ButtonTitle2}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step5: {
                            ...prevValues.SubmissionFormTemplate.step5,
                            ButtonTitle2: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}
                </Grid>
              </Grid>
            </Grid> */}
            <Divider />
            <Grid container alignItems="center" spacing={4} my={2}>
              <Grid item xs={12} sm={12} md={12}>
                <StepHeader>
                  <StepNumber>4</StepNumber>
                  {!isEditing54 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing54(true)} variant="contained">
                      {values.SubmissionFormTemplate.step6.titel}
                    </Box>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step6.titel}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step6: {
                            ...prevValues.SubmissionFormTemplate.step6,
                            titel: e
                          }
                        }
                      }))} className="manageWidth" variant="outlined" />
                  )}

                </StepHeader>
                <Grid item xs={12} sm={6} md={6} mt={2} m={2}>
                  {!isEditing55 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "10px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing55(true)} variant="contained">
                      {values.SubmissionFormTemplate.step6.aggrement}
                    </Box>
                  ) : (
                    <InputControl
                      className="manageWidth"

                      value={values.SubmissionFormTemplate.step6.aggrement}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step6: {
                            ...prevValues.SubmissionFormTemplate.step6,
                            aggrement: e
                          }
                        }
                      }))}
                    />
                  )}

                </Grid>
                <Grid item xs={12} sm={8} md={6} mt={2} sx={{ display: "flex" }}>
                  {!isEditing56 ? (
                    <Button sx={{
                      backgroundColor: 'lightGray',
                      borderRadius: "20px"
                    }} onClick={() => setIsEditing56(true)} variant="contained">
                      {values.SubmissionFormTemplate.step6.ButtonTitle1}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step6.ButtonTitle1}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step6: {
                            ...prevValues.SubmissionFormTemplate.step6,
                            ButtonTitle1: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}&nbsp;
                  {!isEditing57 ? (
                    <Button sx={{
                      backgroundColor: '#212129',
                      borderRadius: "20px"
                    }} onClick={() => setIsEditing57(true)} variant="contained">
                      {values.SubmissionFormTemplate.step6.ButtonTitle2}
                    </Button>
                  ) : (
                    <InputControl
                      value={values.SubmissionFormTemplate.step6.ButtonTitle2}
                      onChange={(e) => setValues(prevValues => ({
                        ...prevValues,
                        SubmissionFormTemplate: {
                          ...prevValues.SubmissionFormTemplate,
                          step6: {
                            ...prevValues.SubmissionFormTemplate.step6,
                            ButtonTitle2: e
                          }
                        }
                      }))}
                      placeholder="Enter text..."
                      autoFocus
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box> : ""
      }
      {activeMenu === "PRIVACY NOTICE" ? (
        <>
          <Box sx={{ margin: "40px", padding: "40px", backgroundColor: "#F6F7FA" }}>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={8} lg={6}>
                <Box sx={{ boxShadow: "0 4px 6px rgba(0, 0, 0, 1)", backgroundColor: "white", padding: "5px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex",alignContent:"center", justifyContent: "left", margin: "0px 5px", padding: "5px", fontSize: "12px", fontStyle: "italic" }}>
                      {`<`}<WarningIcon/>&nbsp;Privacy Notice title area.{`>`}
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider sx={{ backgroundColor: "lightgray" }} />
                    </Grid>
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", justifyContent: "left", margin: "10px", padding: "10px" }}>
                      {`<`}<WarningIcon/>&nbsp;Privacy Notice content area.{`>`} 
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider sx={{ backgroundColor: "lightgray" }} />
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="right" padding="10px">
                      {!isEditing73 ? (
                        <Button
                          sx={{ backgroundColor: "#212129", borderRadius: "20px" }}
                          onClick={() => setIsEditing73(true)}
                          variant="contained"
                        >
                          {values.Notice.ButtonTitle1}
                        </Button>
                      ) : (
                        <InputControl
                          value={values.Notice.ButtonTitle1}
                          onChange={(e) => setValues(prevValues => ({
                            ...prevValues,
                            Notice: {
                              ...prevValues.Notice,
                              ButtonTitle1: e
                            }
                          }))}
                          placeholder="Enter text..."
                          autoFocus
                        />
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : ""}

      {activeMenu === "SUBMITTED PAGE TEMPLATE" ? (
        <>
          <Box sx={{ margin: "0px 40px", backgroundColor: "#F6F7FA" }}>
            <Grid container justifyContent="center">
            <Grid item xs={12} py={2} sx={{display:"flex",alignItems:"center",fontSize:"12px",justifyContent:"center",backgroundColor:"#E7E7E7"}}>
                 <WarningIcon/>&nbsp; Please don't edit or remove markup {`{0}`}
                </Grid>
              <Grid item xs={12} md={8} lg={6}>
                <Box sx={{ padding: "40px", backgroundColor: "#F6F7FA" }}>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {!isEditing58 ? (
                        <Box
                          sx={{ borderRadius: "5px", padding: "10px", border: "1px solid gray" }}
                          onClick={() => setIsEditing58(true)}
                        >
                          {values.SubmittedPageTemplate.title}
                        </Box>
                      ) : (
                        <InputControl
                          fullWidth
                          value={values.SubmittedPageTemplate.title}
                          onChange={(e) =>
                            setValues((prevValues) => ({
                              ...prevValues,
                              SubmittedPageTemplate: {
                                ...prevValues.SubmittedPageTemplate,
                                title: e,
                              },
                            }))
                          }
                          placeholder="Enter title..."
                          autoFocus
                          size="small"
                        />
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      {!isEditing59 ? (
                        <Box
                          sx={{ borderRadius: "5px", padding: "10px", border: "1px solid gray" }}
                          onClick={() => setIsEditing59(true)}
                        >
                          {values.SubmittedPageTemplate.body}
                        </Box>
                      ) : (
                        <InputControl
                          fullWidth
                          
                          minRows={3}
                          value={values.SubmittedPageTemplate.body}
                          onChange={(e) =>
                            setValues((prevValues) => ({
                              ...prevValues,
                              SubmittedPageTemplate: {
                                ...prevValues.SubmittedPageTemplate,
                                body: e
                              },
                            }))
                          }
                          placeholder="Enter body..."
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="center" gap={2}>
                      {!isEditing60 ? (
                        <Button
                          sx={{ padding: "10px", backgroundColor: "#212129", borderRadius: "20px" }}
                          onClick={() => setIsEditing60(true)}
                          variant="contained"
                        >
                          {values.SubmittedPageTemplate.ButtonTitle1}
                        </Button>
                      ) : (
                        <InputControl
                          value={values.SubmittedPageTemplate.ButtonTitle1}
                          onChange={(e) =>
                            setValues((prevValues) => ({
                              ...prevValues,
                              SubmittedPageTemplate: {
                                ...prevValues.SubmittedPageTemplate,
                                ButtonTitle1: e,
                              },
                            }))
                          }
                          placeholder="Enter text..."
                          autoFocus
                          size="small"
                        />
                      )}
                      {!isEditing61 ? (
                        <Button
                          sx={{ padding: "10px", backgroundColor: "#212129", borderRadius: "20px" }}
                          onClick={() => setIsEditing61(true)}
                          variant="contained"
                        >
                          {values.SubmittedPageTemplate.ButtonTitle2}
                        </Button>
                      ) : (
                        <InputControl
                          value={values.SubmittedPageTemplate.ButtonTitle2}
                          onChange={(e) =>
                            setValues((prevValues) => ({
                              ...prevValues,
                              SubmittedPageTemplate: {
                                ...prevValues.SubmittedPageTemplate,
                                ButtonTitle2: e,
                              },
                            }))
                          }
                          placeholder="Enter text..."
                          autoFocus
                          size="small"
                        />
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : ""}

      {activeMenu === "ERROR PAGE" ? (
        <>
          <Box sx={{ margin: "0px 40px", backgroundColor: "#F6F7FA" }}>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={8} sx={{ padding: "25px" }}>
                <Box sx={{ boxShadow: "0 4px 6px rgba(0, 0, 0, 1)", backgroundColor: "#E7E7E7", padding: "40px" }}>
                  <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12} sm={8} md={12}>
                      {!isEditing70 ? (
                        <Box
                          sx={{
                            borderRadius: "5px",
                            padding: "10px",
                            border: "1px solid gray",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => setIsEditing70(true)}
                        >
                          {values.ErrorPage.title}
                        </Box>
                      ) : (
                        <textarea value={values.ErrorPage.title} onChange={(e) => setValues(prevValues => ({
                          ...prevValues,
                          ErrorPage: {
                            ...prevValues.ErrorPage,
                            title: e.target.value
                          }
                        }))} className="manageWidth" />
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={8} textAlign="center" sx={{ padding: "10px" }}>
                      Please contact your Human Resources Representative with any queries or if you need further clarification regarding this document or the Policy.
                    </Grid>

                    {/* <Grid item xs={12} sm={12} md={12} display="flex" justifyContent="center" gap={2}>
                      {!isEditing71 ? (
                        <Button
                          sx={{ padding: "10px", backgroundColor: "#212129", borderRadius: "20px" }}
                          onClick={() => setIsEditing71(true)}
                          variant="contained"
                        >
                          {values.ErrorPage.ButtonTitle1}
                        </Button>
                      ) : (
                        <InputControl
                          value={values.ErrorPage.ButtonTitle1}
                          onChange={(e) =>
                            setValues((prevValues) => ({
                              ...prevValues,
                              ErrorPage: {
                                ...prevValues.ErrorPage,
                                ButtonTitle1: e
                              }
                            }))
                          }
                          placeholder="Enter text..."
                          autoFocus
                          size="small"
                        />
                      )}

                      {!isEditing72 ? (
                        <Button
                          sx={{ padding: "10px", backgroundColor: "#212129", borderRadius: "20px" }}
                          onClick={() => setIsEditing72(true)}
                          variant="contained"
                        >
                          {values.ErrorPage.ButtonTitle2}
                        </Button>
                      ) : (
                        <InputControl
                          value={values.ErrorPage.ButtonTitle2}
                          onChange={(e) =>
                            setValues((prevValues) => ({
                              ...prevValues,
                              ErrorPage: {
                                ...prevValues.ErrorPage,
                                ButtonTitle2: e,
                              },
                            }))
                          }
                          placeholder="Enter text..."
                          autoFocus
                          size="small"
                        />
                      )}
                    </Grid> */}
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : ""}

      {activeMenu === "PDF TEMPLATE" ? (
        <>
          <Box sx={{ padding: "20px", margin: "0px 40px", backgroundColor: "#F6F7FA" }}>
            <Box sx={{ display: "flex", justifyContent: "right" }}>
              <img src={logo} alt="logo" className="logoImgTag"></img>
            </Box>
            <Box>
              {!isEditing62 ? (
                <Box sx={{
                  borderRadius: "5px",
                  padding: "10px",
                  border: "1px solid gray"
                }} onClick={() => setIsEditing62(true)} variant="contained">
                  {values.PdfTemplate.title1}
                </Box>
              ) : (
                <InputControl value={values.PdfTemplate.title1} onChange={(e) => setValues(prevValues => ({
                  ...prevValues,
                  PdfTemplate: {
                    ...prevValues.PdfTemplate,
                    title1: e
                  }
                }))} />
              )}

            </Box>
            <Box sx={{ margin: "10px 0px" }}>
              {!isEditing63 ? (
                <Box sx={{
                  backgroundColor: "#212129",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "5px",
                  padding: "10px",
                  border: "1px solid gray"
                }} onClick={() => setIsEditing63(true)} variant="contained">
                  {values.PdfTemplate.title2}
                </Box>
              ) : (
                <InputControl value={values.PdfTemplate.title2} onChange={(e) => setValues(prevValues => ({
                  ...prevValues,
                  PdfTemplate: {
                    ...prevValues.PdfTemplate,
                    title2: e
                  }
                }))} />
              )}

            </Box>
            <Box sx={{ margin: "10px 0px", border: "1px solid #212129" }}>
              <Box sx={{ padding: "10px" }}>
                {!isEditing82 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing82(true)} variant="contained">
                    {values.PdfTemplate.title3}
                  </Box>
                ) : (
                  <InputControl value={values.PdfTemplate.title3} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    PdfTemplate: {
                      ...prevValues.PdfTemplate,
                      title3: e
                    }
                  }))} />
                )}
              </Box>
              <Box sx={{ margin: "10px 0px" }}>
                {!isEditing64 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing64(true)} variant="contained">
                    {values.PdfTemplate.tableh1}
                  </Box>
                ) : (
                  <InputControl value={values.PdfTemplate.tableh1} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    PdfTemplate: {
                      ...prevValues.PdfTemplate,
                      tableh1: e
                    }
                  }))} />
                )}
              </Box>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell>#</TableCell>
                      <TableCell>COMPANY / MARKET</TableCell>
                      <TableCell>DETAILS OF EXISTING OR POTENTIAL CONFLICT OF INTEREST</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.company}</TableCell>
                        <TableCell>{row.details}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ margin: "10px 0px" }}>
              {!isEditing71 ? (
                <Box sx={{
                  borderRadius: "5px",
                  padding: "10px",
                  border: "1px solid gray"
                }} onClick={() => setIsEditing71(true)} variant="contained">
                  {values.PdfTemplate.tableh2}
                </Box>
              ) : (
                    <InputControl value={values.PdfTemplate.tableh2} onChange={(e) => setValues(prevValues => ({
                      ...prevValues,
                      PdfTemplate: {
                        ...prevValues.PdfTemplate,
                        tableh2: e
                      }
                    }))} />
              )}           
              </Box>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell>#</TableCell>
                      <TableCell>COMPANY / MARKET</TableCell>
                      <TableCell>DETAILS OF EXISTING OR POTENTIAL CONFLICT OF INTEREST</TableCell>
                      <TableCell>Date of Employment</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.company}</TableCell>
                        <TableCell>{row.details}</TableCell>
                        <TableCell>{row.date}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box sx={{ margin: "10px 0px" }}>
              {!isEditing65 ? (
                <Box sx={{
                  borderRadius: "5px",
                  padding: "10px",
                  border: "1px solid gray"
                }} onClick={() => setIsEditing65(true)} variant="contained">
                  {values.PdfTemplate.signOff}
                </Box>
              ) : (
                <InputControl value={values.PdfTemplate.signOff} onChange={(e) => setValues(prevValues => ({
                  ...prevValues,
                  PdfTemplate: {
                    ...prevValues.PdfTemplate,
                    signOff: e
                  }
                }))} />
              )}

            </Box>
            <Box sx={{ margin: "10px 0px", display: "flex", justifyContent: "center" }}>
              <Grid container spacing={2} sx={{ margin: "5px" }}>
                <Grid item xs={12} sm={6} md={3} sx={{ marginTop: "10px" }}>
                  {!isEditing66 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "20px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing66(true)} variant="contained">
                      {values.PdfTemplate.name}
                    </Box>
                  ) : (
                    <InputControl value={values.PdfTemplate.name} onChange={(e) => setValues(prevValues => ({
                      ...prevValues,
                      PdfTemplate: {
                        ...prevValues.PdfTemplate,
                        name: e
                      }
                    }))} fullWidth size="small" label="Signed" variant="outlined" />
                  )}

                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    Jimmy Langiosi
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    Job Title
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    Senior Accountant
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    Employee Name:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    Jimmy Langiosi
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={{ marginTop: "10px" }}>
                  {!isEditing67 ? (
                    <Box sx={{
                      borderRadius: "5px",
                      padding: "20px",
                      border: "1px solid gray"
                    }} onClick={() => setIsEditing67(true)} variant="contained">
                      {values.PdfTemplate.date}
                    </Box>
                  ) : (
                    <InputControl value={values.PdfTemplate.date} onChange={(e) => setValues(prevValues => ({
                      ...prevValues,
                      PdfTemplate: {
                        ...prevValues.PdfTemplate,
                        date: e
                      }
                    }))} type="text" fullWidth size="small" label="Date" variant="outlined" />
                  )}

                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    20 June 2017
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    Company:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    Publicis One - Belgium
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    HFM Code:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={{ padding: "8px", borderRadius: "4px", minHeight: "40px", display: "flex", alignItems: "center" }}>
                    PO390BG
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ margin: "10px 0px" }}>
              {!isEditing68 ? (
                <Box sx={{
                  borderRadius: "5px",
                  padding: "10px",
                  border: "1px solid gray"
                }} onClick={() => setIsEditing68(true)} variant="contained">
                  {values.PdfTemplate.aggrementTitel1}
                </Box>
              ) : (
                <InputControl value={values.PdfTemplate.aggrementTitel1} onChange={(e) => setValues(prevValues => ({
                  ...prevValues,
                  PdfTemplate: {
                    ...prevValues.PdfTemplate,
                    aggrementTitel1: e
                  }
                }))} />
              )}

            </Box>
            <Box sx={{ margin: "10px 0px" }}>
              {!isEditing69 ? (
                <Box sx={{
                  borderRadius: "5px",
                  padding: "10px",
                  border: "1px solid gray"
                }} onClick={() => setIsEditing69(true)} variant="contained">
                  {values.PdfTemplate.aggrementTitel2}
                </Box>
              ) : (
                <InputControl value={values.PdfTemplate.aggrementTitel2} onChange={(e) => setValues(prevValues => ({
                  ...prevValues,
                  PdfTemplate: {
                    ...prevValues.PdfTemplate,
                    aggrementTitel2: e
                  }
                }))} />
              )}

            </Box>
            <Grid container spacing={2} sx={{ margin: "5px",display:"flex",justifyContent:"center" }}>
            {`<`}<WarningIcon/>&nbsp;Policy content here{`>`}
            </Grid>
          </Box>
        </>) : ""}

      {activeMenu === "MASTER PAGE" ?
        (<>
          <Box sx={{ padding: "20px", margin: "0px 40px", backgroundColor: "#F6F7FA" }}>
            <Grid container spacing={2}>
              {/* Page Header */}
              <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Page Header
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {!isEditing74 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing74(true)} variant="contained">
                    {values.MasterPage.pageh1}
                  </Box>
                ) : (
                  <InputControl value={values.MasterPage.pageh1} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    MasterPage: {
                      ...prevValues.MasterPage,
                      pageh1: e
                    }
                  }))} fullWidth variant="outlined" />
                )}

              </Grid>
              <Grid item xs={12}>
                {!isEditing75 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing75(true)} variant="contained">
                    {values.MasterPage.pageh2}
                  </Box>
                ) : (
                  <InputControl value={values.MasterPage.pageh2} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    MasterPage: {
                      ...prevValues.MasterPage,
                      pageh2: e
                    }
                  }))} fullWidth variant="outlined" />
                )}

              </Grid>

              {/* Menu Item */}
              <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Menu item
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                {!isEditing76 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing76(true)} variant="contained">
                    {values.MasterPage.menu1}
                  </Box>
                ) : (
                  <InputControl value={values.MasterPage.menu1} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    MasterPage: {
                      ...prevValues.MasterPage,
                      menu1: e
                    }
                  }))} fullWidth variant="outlined" />
                )}

              </Grid>
              <Grid item xs={12} sm={6}>
                {!isEditing77 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing77(true)} variant="contained">
                    {values.MasterPage.menu2}
                  </Box>
                ) : (
                  <InputControl value={values.MasterPage.menu2} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    MasterPage: {
                      ...prevValues.MasterPage,
                      menu2: e
                    }
                  }))} fullWidth variant="outlined" />
                )}

              </Grid>

              {/* Page Titles */}
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Page title: My Submission
                </Typography>
                {!isEditing78 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing78(true)} variant="contained">
                    {values.MasterPage.Pagetitle1}
                  </Box>
                ) : (
                  <InputControl value={values.MasterPage.Pagetitle1} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    MasterPage: {
                      ...prevValues.MasterPage,
                      Pagetitle1: e
                    }
                  }))} fullWidth variant="outlined" />
                )}

              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Page title: Submitted Page
                </Typography>
                {!isEditing79 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing79(true)} variant="contained">
                    {values.MasterPage.Pagetitle2}
                  </Box>
                ) : (
                  <InputControl value={values.MasterPage.Pagetitle2} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    MasterPage: {
                      ...prevValues.MasterPage,
                      Pagetitle2: e
                    }
                  }))} fullWidth variant="outlined" />
                )}

              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Page title: Submission Form
                </Typography>
                {!isEditing80 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing80(true)} variant="contained">
                    {values.MasterPage.Pagetitle3}
                  </Box>
                ) : (
                  <InputControl value={values.MasterPage.Pagetitle3} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    MasterPage: {
                      ...prevValues.MasterPage,
                      Pagetitle3: e
                    }
                  }))} fullWidth variant="outlined" />
                )}

              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle1" fontWeight="bold">
                  Page title: Error Page
                </Typography>
                {!isEditing81 ? (
                  <Box sx={{
                    borderRadius: "5px",
                    padding: "10px",
                    border: "1px solid gray"
                  }} onClick={() => setIsEditing81(true)} variant="contained">
                    {values.MasterPage.Pagetitle4}
                  </Box>
                ) : (
                  <InputControl value={values.MasterPage.Pagetitle4} onChange={(e) => setValues(prevValues => ({
                    ...prevValues,
                    MasterPage: {
                      ...prevValues.MasterPage,
                      Pagetitle4: e
                    }
                  }))} fullWidth variant="outlined" />
                )}

              </Grid>
            </Grid>
          </Box></>) : ""
      }
      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{ marginTop: "20px" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{ margin: "20px", display: "flex", justifyContent: "center" }}
        >
          <CustomButton onClick={handleSubmit} label="Save Form Template" isDisabled={!isFormValid()} />
          &nbsp;&nbsp;
          <CustomButton onClick={() => {
            navigate(`/app-vcoi/vcoisitecontent/VcoiManageFormLabels`);
          }} label="Cancel" />
        </Grid>
      </Grid>
    </>
  );
}
